let dd = require("ES/lib/dd");

module.exports = dd.createClass({
	render(){
		let {event} = this.props;
		if(!event || !event.accountinglocked){
			return dd.span();
		}
		return dd.div({className: "alert alert-warning"},
			dd.i({className: "fa fa-lock"}), " Be advised this event is accounting-locked."
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/AccountingLockedWarning.js